import React, { useEffect } from 'react'
import { IRequestedItem, ItemsRequestModel } from '.'
import { RequestedItem } from './SelectRequestedItems'
import { Avatar } from '@mui/material'
import NoThumb from "../../assets/svg/no-thumb.svg"
import GenerateIcon from '../../components/GenerateIcon'
import { useLocation } from 'react-router-dom'
import StatusChip from '../../components/StatusChip'
import DateAndTime from '../DateAndTime'
import { useDispatch } from 'react-redux'
import { handleCloseElementQuickPreview, handleOpenElementQuickPreview } from '../admin/adminPagesSlice'
import ItemsApp from '../items/ItemsApp'
import Thumbnail from '../../components/Thumbnail'

interface IReturnedRequestedItemBoxProps {
    requestedItem: IRequestedItem,
}

export function ReturnedRequestedItemBox(props: IReturnedRequestedItemBoxProps){

    const dispatch = useDispatch()

    const { requestedItem } = props
    const { item_id, item, allocations, quantity, damaged, missing } = requestedItem

    const location = useLocation()
    const isItemRequestPage = location.pathname.includes("/panel/item_requests")

    const dateAndTime = new DateAndTime()

    return(
        <div className="requsted-item-wrapper">

            <div className="requsted-item-box-container">
                <div className="content-of-requsted-item-box-container">

                    <div className="fields-of-requsted-item-box-container">
                        <div className="content-of-fields-of-requsted-item-box-container">

                            <div className="field-of-requsted-item-box-container thumbnail">
                                <div className="content-of-field-of-requsted-item-box-container">
                                    {/* <Avatar src={item.thumbnail ? item.thumbnail : NoThumb}>
                                        <GenerateIcon icon="image" />
                                    </Avatar> */}
                                    <Thumbnail src={item.thumbnail ? item.thumbnail : NoThumb} />
                                </div>
                            </div>

                            <div className="field-of-requsted-item-box-container text">
                                <div className="content-of-field-of-requsted-item-box-container">
                                    <StatusChip type="returned" />
                                </div>
                            </div>

                            <div className="field-of-requsted-item-box-container text" style={{ minWidth: 200, maxWidth: 200 }}>
                                <div className="content-of-field-of-requsted-item-box-container">
                                    <h4>Item</h4>
                                    {/* <a href={isItemRequestPage ? `/panel/items/view/${item.unique_id}` : `/items/${item.unique_id}`} target="_blank"><h3>{item.title}</h3></a> */}
                                    <h3 style={{ cursor: "pointer" }} onClick={() => {
                                        handleOpenElementQuickPreview(
                                            item.id,
                                            item.title,
                                            () => new ItemsApp(),
                                            dispatch,
                                            [
                                                {
                                                    label: "Close",
                                                    color: "error",
                                                    onClick: () => handleCloseElementQuickPreview(dispatch)
                                                }
                                            ],
                                            false,
                                            undefined,
                                            true
                                        )
                                    }}>{item.title}</h3>
                                </div>
                            </div>

                            <div className="field-of-requsted-item-box-container text" style={{ minWidth: 200, maxWidth: 200 }}>
                                <div className="content-of-field-of-requsted-item-box-container">
                                    <h4>Unique ID</h4>
                                    <h3>{item.unique_id}</h3>
                                </div>
                            </div>

                            <div className="field-of-requsted-item-box-container text" style={{ minWidth: 200, maxWidth: 200 }}>
                                <div className="content-of-field-of-requsted-item-box-container">
                                    <h4>Serial Number</h4>
                                    <h3>{item.serial_number ? item.serial_number : "-"}</h3>
                                </div>
                            </div>

                            <div className="field-of-requsted-item-box-container text" style={{ minWidth: 200, maxWidth: 200 }}>
                                <div className="content-of-field-of-requsted-item-box-container">
                                    <h4>Returned on</h4>
                                    <h3>{requestedItem.returned_at ? dateAndTime.formatDateAndTime(requestedItem.returned_at) : "-"}</h3>
                                </div>
                            </div>

                        </div>
                    </div>
{/* 
                    {!viewRequestPage ? (
                      <div className="action-buttons-of-requsted-item-box-container">
                          <div className="content-of-action-buttons-of-requsted-item-box-container">

                              <Button className="general-button admin-button" color="success" onClick={() => setOpen(true)}>Update Quantity</Button>
                              <Button className="general-button admin-button" color="error" onClick={() => deleteItem(item_id)}>Delete</Button>

                          </div>
                      </div>
                    ) : (
                        <div className="action-buttons-of-requsted-item-box-container">
                            <div className="content-of-action-buttons-of-requsted-item-box-container">

                              {showReportButton && <Button className="general-button admin-button" color="error" onClick={() => showReport(requestedItem)}>Report</Button>}

                            </div>
                        </div>
                    )} */}

                </div>
            </div>

        </div>
    )
}

interface IReturnedRequestedItemsProps {
    items: IRequestedItem[],
    viewRequestPage?: boolean,
    request: ItemsRequestModel,
    loadingItems: boolean,
    hideTitle?: boolean
}

export default function ReturnedRequestedItems(props: IReturnedRequestedItemsProps) {

    const { 
        items,
        viewRequestPage,
        request,
        loadingItems,
        hideTitle,
    } = props

    let title: string = "Returned Items"


    let list = items.filter(item => item.is_returned === true && item.missing === 0)


    if (loadingItems){
        return <></>
    }

    if (list.length === 0){
        return <></>
    }

    return(
        <div className="requsted-items-of-single-items-request-page-container returned-items">
            {!hideTitle && <h3 className="requested-items-title">{title} ({list.length})</h3>}

            <div className="content-of-requested-items-container">
            
                <div className="requested-items-list">
                    {list.map((item, index: number) => <ReturnedRequestedItemBox requestedItem={item} key={index} />)}
                </div>
            
            </div>
        </div>
    )
}